import styled from 'styled-components';

export const Arrow = styled('div')<{
  value: number;
  position: number;
}>`
  height: 47px;
  width: 27px;
  margin-top: 5px;
  transform: ${(props) =>
    `translateX(${props.position}px) rotate(${
      props.value < 0 ? '0' : '180'
    }deg)`};
`;

export const CounterContainer = styled('div')`
  display: flex;
`;

export const DescriptionText = styled('p')<{
  width: number;
  fontSize?: number;
}>`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  color: ${(props) => props.theme.atlas.semantic.color.type.disabled};
  font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : '20px')};
  text-align: center;
  width: ${(props) => props.width}px;
  margin: 0;
`;
